module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("基础管理")])]), _vm._v(" "), _c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("库区库位管理")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-content-main"
  }, [_c('div', {
    staticClass: "treeLeft"
  }, [(_vm.warehouseBut.addBut) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addWarehouse
    }
  }, [_vm._v("＋")]) : _vm._e(), _vm._v(" "), (!_vm.warehouseBut.selectBut) ? _c('div', {
    staticClass: "canNot"
  }, [_vm._v(" 暂无查看仓库权限 ")]) : _vm._e(), _vm._v(" "), (_vm.warehouseBut.selectBut) ? _c('warehouse-tree', {
    attrs: {
      "deptData": _vm.warehouseLists,
      "selectedId": _vm.dePtNodeSelect
    },
    on: {
      "getCurrDate": _vm.getCurr
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "treeRight"
  }, [_c('div', [_c('div', {
    staticClass: "houseTitle"
  }, [_vm._v("仓库管理")]), _vm._v(" "), (!_vm.warehouseBut.selectBut) ? _c('div', {
    staticClass: "canNot"
  }, [_vm._v(" 暂无查看仓库权限 ")]) : _vm._e(), _vm._v(" "), (_vm.warehouseBut.selectBut) ? _c('Form', {
    ref: "formWarehouse",
    attrs: {
      "model": _vm.formWarehouse,
      "rules": _vm.ruleWarehouse,
      "label-width": 86
    }
  }, [_c('div', {
    staticClass: "formLine"
  }, [_c('FormItem', {
    attrs: {
      "label": "供应商代码",
      "prop": "supplierId"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": "请选择供应商代码"
    },
    on: {
      "on-change": _vm.mySupplierIdChange
    },
    model: {
      value: (_vm.formWarehouse.supplierId),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "supplierId", $$v)
      },
      expression: "formWarehouse.supplierId"
    }
  }, _vm._l((_vm.supplierDate), function(item) {
    return _c('Option', {
      class: [_vm.formWarehouse.supplierId == item.dlvSiteCode ? 'ivu-select-selected-value' : ''],
      attrs: {
        "value": item.dlvSiteName
      }
    }, [_vm._v(_vm._s(item.dlvSiteCode))])
  }))], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "供应商名称",
      "prop": "supplierName"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": "请选择供应商名称"
    },
    on: {
      "on-change": _vm.mySupplierNameChange
    },
    model: {
      value: (_vm.formWarehouse.supplierName),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "supplierName", $$v)
      },
      expression: "formWarehouse.supplierName"
    }
  }, _vm._l((_vm.supplierDate), function(item) {
    return _c('Option', {
      class: [_vm.formWarehouse.supplierName == item.dlvSiteCode ? 'ivu-select-selected-value' : ''],
      attrs: {
        "value": item.dlvSiteCode,
        "label-in-value": "true"
      }
    }, [_vm._v(_vm._s(item.dlvSiteName))])
  }))], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "仓库代码",
      "prop": "warehouseId"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": ""
    },
    model: {
      value: (_vm.formWarehouse.warehouseId),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "warehouseId", $$v)
      },
      expression: "formWarehouse.warehouseId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formLine"
  }, [_c('FormItem', {
    attrs: {
      "label": "仓库名称",
      "prop": "warehouseName"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": ""
    },
    model: {
      value: (_vm.formWarehouse.warehouseName),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "warehouseName", $$v)
      },
      expression: "formWarehouse.warehouseName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "仓库容量",
      "prop": "warehouseSize"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": ""
    },
    model: {
      value: (_vm.formWarehouse.warehouseSize),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "warehouseSize", $$v)
      },
      expression: "formWarehouse.warehouseSize"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "仓库类型",
      "prop": "warehouseType"
    }
  }, [_c('Select', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": "请选择仓库类型"
    },
    model: {
      value: (_vm.formWarehouse.warehouseType),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "warehouseType", $$v)
      },
      expression: "formWarehouse.warehouseType"
    }
  }, [_c('Option', {
    class: [_vm.formWarehouse.warehouseType == '10' ? 'ivu-select-selected-value' : ''],
    attrs: {
      "value": "10"
    }
  }, [_vm._v("自有")]), _vm._v(" "), _c('Option', {
    class: [_vm.formWarehouse.warehouseType == '20' ? 'ivu-select-selected-value' : ''],
    attrs: {
      "value": "20"
    }
  }, [_vm._v("他人")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formLine"
  }, [_c('FormItem', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "是否默认",
      "prop": "isDefault"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formWarehouse.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "isDefault", $$v)
      },
      expression: "formWarehouse.isDefault"
    }
  }, [_c('Radio', {
    class: [_vm.formWarehouse.isDefault == '1' ? 'ivu-radio-checked' : ''],
    attrs: {
      "disabled": !_vm.editMsg,
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Radio', {
    class: [_vm.formWarehouse.isDefault == '0' ? 'ivu-radio-checked' : ''],
    attrs: {
      "disabled": !_vm.editMsg,
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "仓库联系人",
      "prop": "contact"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": ""
    },
    model: {
      value: (_vm.formWarehouse.contact),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "contact", $$v)
      },
      expression: "formWarehouse.contact"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "联系人电话",
      "prop": "contactPhone"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": ""
    },
    model: {
      value: (_vm.formWarehouse.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "contactPhone", $$v)
      },
      expression: "formWarehouse.contactPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": !_vm.editMsg,
      "placeholder": ""
    },
    model: {
      value: (_vm.formWarehouse.address),
      callback: function($$v) {
        _vm.$set(_vm.formWarehouse, "address", $$v)
      },
      expression: "formWarehouse.address"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary",
      "disabled": _vm.addDisabled
    },
    on: {
      "click": function($event) {
        _vm.warehouseSubmit('formWarehouse')
      }
    }
  }, [_vm._v("保存仓库")]), _vm._v(" "), (_vm.warehouseBut.updateBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.warehouseUpdate('formWarehouse')
      }
    }
  }, [_vm._v("修改仓库")]) : _vm._e(), _vm._v(" "), (_vm.warehouseBut.delBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.delWarehouseMod = true
      }
    }
  }, [_vm._v("删除仓库")]) : _vm._e(), _vm._v(" "), _c('Button', {
    staticClass: "mRight",
    attrs: {
      "disabled": _vm.addDisabled,
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        _vm.warehouseReset('formWarehouse')
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "houseTitle"
  }, [_vm._v("库区管理")]), _vm._v(" "), _c('div', {
    staticClass: "method-wrapper"
  }, [(_vm.reservoirBut.addBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addReservoir
    }
  }, [_vm._v("新增库区")]) : _vm._e(), _vm._v(" "), (_vm.reservoirBut.updateBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.upDateReservoir
    }
  }, [_vm._v("修改库区")]) : _vm._e(), _vm._v(" "), (_vm.reservoirBut.delBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delReservoir
    }
  }, [_vm._v("删除库区")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [(!_vm.reservoirBut.selectBut) ? _c('div', {
    staticClass: "canNot"
  }, [_vm._v(" 暂无查看库区权限 ")]) : _vm._e(), _vm._v(" "), (_vm.reservoirBut.selectBut) ? _c('Table', {
    ref: "reservoirSelect",
    staticStyle: {
      "min-width": "600px",
      "margin-bottom": "20px"
    },
    attrs: {
      "border": "",
      "columns": _vm.columnsReservoir,
      "data": _vm.reservoirData.data
    },
    on: {
      "on-selection-change": _vm.reservoirSelected
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "houseTitle"
  }, [_vm._v("库位管理")]), _vm._v(" "), _c('div', {
    staticClass: "method-wrapper"
  }, [(_vm.locationBut.addBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addLocation
    }
  }, [_vm._v("新增库位")]) : _vm._e(), _vm._v(" "), (_vm.locationBut.updateBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.upDateLocation
    }
  }, [_vm._v("修改库位")]) : _vm._e(), _vm._v(" "), (_vm.locationBut.delBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delLocation
    }
  }, [_vm._v("删除库位")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [(!_vm.locationBut.selectBut) ? _c('div', {
    staticClass: "canNot"
  }, [_vm._v(" 暂无查看库位权限 ")]) : _vm._e(), _vm._v(" "), (_vm.locationBut.selectBut) ? _c('Table', {
    ref: "selection",
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "border": "",
      "columns": _vm.columnsLocation,
      "data": _vm.locationData.data
    },
    on: {
      "on-selection-change": _vm.locationSelected
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.locationData.page.totalCount,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.onChangeLocation,
      "on-page-size-change": _vm.sizeChangeLocation
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新增",
      "mask-closable": false
    },
    model: {
      value: (_vm.ReservoirModel),
      callback: function($$v) {
        _vm.ReservoirModel = $$v
      },
      expression: "ReservoirModel"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.ReservoirName))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Form', {
    ref: "reservoirValidate",
    attrs: {
      "model": _vm.reservoirValidate,
      "rules": _vm.ruleReservoir,
      "label-width": 80
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "库区代码",
      "prop": "reservoirId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入库区代码"
    },
    model: {
      value: (_vm.reservoirValidate.reservoirId),
      callback: function($$v) {
        _vm.$set(_vm.reservoirValidate, "reservoirId", $$v)
      },
      expression: "reservoirValidate.reservoirId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "库区名称",
      "prop": "reservoirName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入库区名称"
    },
    model: {
      value: (_vm.reservoirValidate.reservoirName),
      callback: function($$v) {
        _vm.$set(_vm.reservoirValidate, "reservoirName", $$v)
      },
      expression: "reservoirValidate.reservoirName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "默认入库",
      "prop": "isIn"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.reservoirValidate.isIn),
      callback: function($$v) {
        _vm.$set(_vm.reservoirValidate, "isIn", $$v)
      },
      expression: "reservoirValidate.isIn"
    }
  }, [_c('Radio', {
    class: [_vm.reservoirValidate.isIn == '1' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Radio', {
    class: [_vm.reservoirValidate.isIn == '0' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "默认出库",
      "prop": "isOut"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.reservoirValidate.isOut),
      callback: function($$v) {
        _vm.$set(_vm.reservoirValidate, "isOut", $$v)
      },
      expression: "reservoirValidate.isOut"
    }
  }, [_c('Radio', {
    class: [_vm.reservoirValidate.isOut == '1' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Radio', {
    class: [_vm.reservoirValidate.isOut == '0' ? 'ivu-radio-checked' : ''],
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.modal_loading
    },
    on: {
      "click": function($event) {
        _vm.submitReservoir('reservoirValidate')
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新增",
      "mask-closable": false
    },
    model: {
      value: (_vm.LocationModel),
      callback: function($$v) {
        _vm.LocationModel = $$v
      },
      expression: "LocationModel"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.LocationName))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Form', {
    ref: "locationValidate",
    attrs: {
      "model": _vm.locationValidate,
      "rules": _vm.ruleLocation,
      "label-width": 85
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "库位代码",
      "prop": "locationId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入库位代码"
    },
    model: {
      value: (_vm.locationValidate.locationId),
      callback: function($$v) {
        _vm.$set(_vm.locationValidate, "locationId", $$v)
      },
      expression: "locationValidate.locationId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "库位名称",
      "prop": "locationName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入库位名称"
    },
    model: {
      value: (_vm.locationValidate.locationName),
      callback: function($$v) {
        _vm.$set(_vm.locationValidate, "locationName", $$v)
      },
      expression: "locationValidate.locationName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "库位描述",
      "prop": "locationInfo"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入库位描述"
    },
    model: {
      value: (_vm.locationValidate.locationInfo),
      callback: function($$v) {
        _vm.$set(_vm.locationValidate, "locationInfo", $$v)
      },
      expression: "locationValidate.locationInfo"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "宽度上限",
      "prop": "locationMax"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入宽度上限"
    },
    model: {
      value: (_vm.locationValidate.locationMax),
      callback: function($$v) {
        _vm.$set(_vm.locationValidate, "locationMax", $$v)
      },
      expression: "locationValidate.locationMax"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "宽度下线",
      "prop": "locationMin"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入宽度下线"
    },
    model: {
      value: (_vm.locationValidate.locationMin),
      callback: function($$v) {
        _vm.$set(_vm.locationValidate, "locationMin", $$v)
      },
      expression: "locationValidate.locationMin"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "额定捆包数",
      "prop": "locationNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入额定捆包数"
    },
    model: {
      value: (_vm.locationValidate.locationNum),
      callback: function($$v) {
        _vm.$set(_vm.locationValidate, "locationNum", $$v)
      },
      expression: "locationValidate.locationNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.modal_loading
    },
    on: {
      "click": function($event) {
        _vm.submitLocation('locationValidate')
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Title",
      "mask-closable": false
    },
    model: {
      value: (_vm.delWarehouseMod),
      callback: function($$v) {
        _vm.delWarehouseMod = $$v
      },
      expression: "delWarehouseMod"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("确认删除")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            删除仓库会删除该仓库及下面所有的库区、库位。"), _c('br'), _vm._v("\n            您确定删除吗？\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.delWarehouseMod = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.delWarehouse('formWarehouse')
      }
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71ebfbe4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BaseManager/warehouse.vue
// module id = 927
// module chunks = 1